// @flow

import { call, fork, put, take } from 'redux-saga/effects'
import { UPDATE_PAYMENT_METHOD, updatePaymentMethod, getPaymentMethods } from 'src/redux/actions/payments/payments'
import http from 'src/services/http'
// types
import type { IOEffect } from 'redux-saga/effects'

function * watchUpdatePaymentMethod(): Generator<IOEffect, void, any> {
  while (true) {
    const {
      payload: { token, data },
    } = yield take(UPDATE_PAYMENT_METHOD.REQUEST)

    try {
      yield call(http, 'api/payment/payment-method', {
        method: 'PUT',
        body: JSON.stringify({
          token,
          data,
        }),
      })

      yield put(updatePaymentMethod.success())
      yield put(getPaymentMethods.request())
    } catch (e) {
      yield put(updatePaymentMethod.error(e.message))
    }
  }
}

export default [fork(watchUpdatePaymentMethod)]
